import React, { useEffect, useState } from 'react'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import axios from '../../../data/http/axios'
import DateTimeFunctions from '../../../Classes/dateTimeFunctions'

export default function Release({ id }) {
    const [release, setRelease] = useState(null)

    useEffect(() => {
        axios.get('/release/' + id).then(r => setRelease(r.data))
    }, [id])

    if (!release) return <LoadingIcons />

    return (
        <div className='release'>
            <div className='release-date'>{DateTimeFunctions.formatDateTime(release.releaseDate, "6")}</div>
            <h2 className='release-title'>{release.title}</h2>
            <div className='release-content' dangerouslySetInnerHTML={{ __html: release.notes }}></div>
        </div>
    )
}